import { connectAdvanced } from 'react-redux';

function selectorFactory() {
    return (nextState, nextOwnProps) => {
        return { ...nextOwnProps, configs: nextState.configs };
    };
}

export default connectAdvanced(selectorFactory, { getDisplayName: () => `ConfigsContainer` });



// WEBPACK FOOTER //
// ./src/components/containers/ConfigsContainer.js